import { Link, useSearch } from "wouter";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function SuccessPage() {
  const search = useSearch();
  const params = new URLSearchParams(search);
  const sessionId = params.get("session_id");

  return (
    <Card className="font-sans w-full max-w-md">
      <CardHeader>
        <div className="flex justify-center">
          <CheckCircle2 className="size-16 text-primary" aria-hidden />
        </div>
        <CardTitle className="text-center text-xl sm:text-2xl">
          Pagamento completato
        </CardTitle>
        <CardDescription className="text-center">
          Grazie per esserti registrato. A breve riceverai una email con i dettagli per accedere.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {sessionId && (
          <p className="text-muted-foreground text-center text-sm">
            ID sessione: {sessionId}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
